import { AddNewActionItemsAttachmentDetails } from "../common/action-attachment.model"
import { AddNewActionItemsAssignementDeatails } from "../common/assignment-details.model"
import { ChangeDataItem } from "./change-data-item.model"

export class ChangeDataActionResponseDto {
    items: ChangeDataItem[] = []
    attachments?: AddNewActionItemsAttachmentDetails[];
    assignmentDetails?: AddNewActionItemsAssignementDeatails;
}